import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import DataTable from './datatable';

import PageSubHeader from '../../pagesubheader'
import ContainerHeader from '../../../components/ContainerHeader/index';
import * as documentdetails from '../../../actions/documentdetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';

class DocumentList extends Component {

    constructor(props) {
        super(props)
        this.state = { committee_id: Number(this.props.params.id ? this.props.params.id : this.props.loginUser.data.committee_id) }
    }
    handleChangeTeam(e) {
        this.setState({ committee_id: Number(e.target.value) })
        this.props.actions.getDocumentDetailsList(e.target.value);
        this.props.loginUser.data.committee_id = e.target.value;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }

    componentDidMount() {
        // console.log('this.state.committee_id', this.state.committee_id)
        this.props.actions.loadswitchercommittees();
        if (this.state.committee_id > 0)
            this.props.actions.getDocumentDetailsList(this.state.committee_id);
    }

    handleUserInput(filterText) {
        this.setState({ filterText: filterText });
    };
    render() {
        const { getDataList, teamDetails, match } = this.props;

        let dataList = <tr><td></td></tr>;
        let message = null;
        // console.log('getDataList', getDataList);
        if ((getDataList && getDataList.Status) || (teamDetails && teamDetails.Status)) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (getDataList && getDataList.documentdetailsList && getDataList.documentdetailsList.length > 0) {
            // dataList = getDataList.documentdetailsList.map((_data, index) => {
            //     return (<TableCell key={index} data={_data} index={index} />);
            // })
        }
        return (
            <div className="slideInUpTiny ">
                {message}
                <ContainerHeader title="Library List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <PageSubHeader committee_id={this.state.committee_id} handleChangeTeam={this.handleChangeTeam.bind(this)}
                            teamDetails={teamDetails} 
                            onUserInput={this.handleUserInput.bind(this)} />
                        <div className="row">
                            <div className="col-12">
                                <DataTable data={getDataList && getDataList.documentdetailsList && getDataList.documentdetailsList.length > 0 ? getDataList.documentdetailsList : null} 
                                 filterText={this.state.filterText} />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { loginUser, documentDetails, teamDetails } = state
    const { match } = ownProps
    return { loginUser, getDataList: documentDetails, teamDetails, params: ownProps.match.params, match }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, documentdetails, loadswitchercommittees), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(DocumentList);



// WEBPACK FOOTER //
// ./app/documentdetails/documentlist/index.js